// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"661":"00a7b410","1346":"f4e20f7e","2589":"d58c8f4e"}[chunkId] + ".css";
};